function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { sort_out_arguments } from './findPhoneNumbers';
import PhoneNumberMatcher from './PhoneNumberMatcher';

/**
 * @return ES6 `for ... of` iterator.
 */
export default function searchNumbers(arg_1, arg_2, arg_3, arg_4) {
	var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4),
	    text = _sort_out_arguments.text,
	    options = _sort_out_arguments.options,
	    metadata = _sort_out_arguments.metadata;

	var matcher = new PhoneNumberMatcher(text, options, metadata);

	return _defineProperty({}, Symbol.iterator, function () {
		return {
			next: function next() {
				if (matcher.hasNext()) {
					return {
						done: false,
						value: matcher.next()
					};
				}
				return {
					done: true
				};
			}
		};
	});
}
//# sourceMappingURL=searchNumbers.js.map